import { useEffect, useState } from 'react';

import { ClientAnalyticsData } from '../../../../interfaces/entity-dashboard/ClientAnalyticsData';
import { entityDashboardService } from '../../../../services/entityDashboardService';
import { getDateRangeByPreset } from '../../../../../shared/utils/getDateRangeByPreset/getDateRangeByPreset';
import { DateRangePreset } from '../../../../../shared/constants/dateRangePreset';
import { SolutionTypeFilter } from '../../../../../shared/constants/user-info/solutionType';

type UseClientAnalyticsDataParams = {
  dateRangePreset: DateRangePreset;
  solutionTypeFilter: SolutionTypeFilter;
};

type UseClientAnalyticsDataReturn = {
  clientAnalyticsData: ClientAnalyticsData | null;
};

export const useClientAnalyticsData = ({
  dateRangePreset,
  solutionTypeFilter,
}: UseClientAnalyticsDataParams): UseClientAnalyticsDataReturn => {
  const [clientAnalyticsData, setClientAnalyticsData] =
    useState<ClientAnalyticsData | null>(null);

  const fetchClientAnalyticsData = async () => {
    const dateRange = getDateRangeByPreset(dateRangePreset);

    const data = await entityDashboardService.getClientAnalytics({
      ...dateRange,
      solutionType: solutionTypeFilter,
    });

    setClientAnalyticsData(data);
  };

  useEffect(() => {
    fetchClientAnalyticsData();
  }, [dateRangePreset, solutionTypeFilter]);

  return { clientAnalyticsData };
};
